
import { useRedirect, useNotify, useTranslate, CreateProps, FormProps } from "react-admin";
import {  CgCreate } from "../../../components/common";
import { RecordType } from "zod";
import { Resources } from "../../resource";
import Form from "./Form";


export interface CgCreateProps extends CreateProps {
  onClose?: () => any;
  formProps?: FormProps<RecordType<any, any>>;
} 
const CreatePopup = (props: CgCreateProps) => {
  const redirect = useRedirect();
  const notify = useNotify();
  const t = useTranslate();

  const onSuccess = () => {
    const currentUrl = window.location.href;
    const origin = window.location.origin;
    const redirectValue = currentUrl.replace(origin, '');

    notify(t('module.prediction.system-configs.validate.createSuccess'), { type: 'success', autoHideDuration: 1000 });

    if (props.onClose) {
      props.onClose();
    }
    if (props.resource) {
      redirect(redirectValue, props.resource);
    }
  };

  const onError = (error: any) => {
    const errorCode = error?.body?.code;
    const notifyError = (msg: string) => {
      notify(msg, { type: 'error' });
    };

    switch (errorCode) {
      case 'KEY_REQUIRED':
        notifyError(t('module.prediction.system-configs.validate.keyRequired'));
        break;
      case 'VALUE_REQUIRED':
        notifyError(t('module.prediction.system-configs.validate.valueRequired'));
        break;
      case 'CRON_MONITOR_KEY_VALUE_EXISTS':
        notifyError(t('module.prediction.system-configs.validate.cronMonitorKeyValueExists'));
        break;
      case 'INTERNAL_SERVER_ERROR':
        notifyError(error?.message || t('module.prediction.system-configs.unknownError'));
        break;
      default:
        notifyError(t('module.prediction.system-configs.unknownError'));
    }
  };

  return (
    <CgCreate
      {...props}
      title="module.prediction.system-configs.create"
      resource={Resources.predictionConfigs}
      onClose={props.onClose}
      mutationOptions={{ onSuccess, onError }}
    >
      <Form isCreate />
    </CgCreate>
  );
};

export default CreatePopup;

